import { render, staticRenderFns } from "./PFrunpayslips.vue?vue&type=template&id=4ce56cde"
import script from "./PFrunpayslips.vue?vue&type=script&lang=js"
export * from "./PFrunpayslips.vue?vue&type=script&lang=js"
import style0 from "./PFrunpayslips.vue?vue&type=style&index=0&id=4ce56cde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports